(function() {
  angular.module('registration')
  .controller('registrationController', ['$scope', '$q', 'registrationUserService', '$log', '$state', '$timeout', '$http', '$rootScope', '$translate',
    function($scope, $q, registrationUserService, $log, $state,$timeout, $http, $rootScope, $translate) {
      var vm = this;
      vm.submit = submit;
      vm.reset = reset;
      vm.model = undefined;
      vm.stateParams = $state.params;
      vm.applicationName = $rootScope.applicationName;
      var errorsToShow = ['taxId','uniqueList','duplicateDsoTaxId', 'duplicateProviderTaxId'];
      if(vm.stateParams.guid) {
        $http.get('dsoValidate/', {params:{'guid':vm.stateParams.guid, 'userId':vm.stateParams.id}}).then((response) => {
          if(!response.data) {
            $state.go('root',{allParams : {
              showConfirmationMessage: "The email verification link is invalid.", type: 'danger'}
              });
          }
        });
      }
      if (registrationUserService.createUserModel().userSaved) {
        //Looks like they want to make another user, clear out the model
        registrationUserService.init();
      }
      vm.model = registrationUserService.registrationModel();
      
      $scope.$watch('errorControl', function() {
        $scope.errorControl && $scope.errorControl.showErrors(errorsToShow);
      });

      function submit() {
        $scope.errorControl.showErrors();
        if ($scope.registrationForm.$valid) {
          $log.debug("User", vm.model);
          vm.model.id = vm.stateParams.id;
          vm.model.emailVerificationGuid = vm.stateParams.guid;
          vm.model.userType = vm.stateParams.type;
          if (vm.stateParams.id && !vm.model.taxIds) {
            vm.model.taxIds = [];
          }
          registrationUserService.registrationModel(vm.model);
          $state.go('createUser');
        }
      }

      function reset() {
        document.getElementById('registrationForm').reset();
        $scope.errorControl.showErrors(errorsToShow);
        vm.model = registrationUserService.registrationModel({});
      }

    }]);
})();
